<!-- 班级报告：四象限图右侧「象限图解读」 -->
<template>
  <div class="class-quadrant-interp flex-column" v-if="interp">
    <div class="class-quad-title">象限图解读</div>
    <div class="class-quad-card">
      <div class="class-quad-block">
        <div class="class-quad-subtitle">关于坐标系</div>
        <p>坐标系横轴：规范书写（居中+占格+组合+多画），通过针对性练习可较快提升。</p>
        <p>坐标系纵轴：笔画功底（重心+笔画+收放），更依赖长期书写积累，需逐步内化。</p>
        <p>原点：全国平均书写水平。</p>
      </div>
      <div class="class-quad-block">
        <div class="class-quad-subtitle">整体概况</div>
        <p class="class-quad-overview">
          本班共 <span class="Comment_highlight">{{ interp.total }}</span> 人，占比最高的象限是<span
            class="Comment_highlight">{{ interp.maxName }}</span>（<span
            class="Comment_highlight">{{ interp.maxRatio }}</span>%），占比最低的是<span
            class="Comment_highlight">{{ interp.minName }}</span>（<span
            class="Comment_highlight">{{ interp.minRatio }}</span>%）。各象限具体分布如下：
        </p>
        <div class="class-quad-item" v-for="q in visibleQuads" :key="q.index">
          <p class="class-quad-item-head">
            {{ q.index }}. {{ q.name }}：共<span class="Comment_highlight">{{ q.count }}</span> 人，占班级的<span
              class="Comment_highlight">{{ q.ratio }}</span>%。
          </p>
          <p>
            <span class="class-quad-label">特点：</span>{{ q.trait }}包括：{{ q.namesText }}。
          </p>
          <p class="class-quad-advice">
            <span class="class-quad-label">建议：</span>{{ q.advice }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildClassMatrixInterpFromStuList } from '../report/quadrantGradeAxis'

export default {
  name: 'ClassQuadrantInterp',
  props: {
    /** 与 fourQuadrants 的 chartData 相同：含 stuList */
    chartData: {
      type: Object,
      default: null,
    },
    gradeValue: {
      type: [Number, String],
      default: null,
    },
    factorMap: {
      type: Object,
      default: null,
    },
  },
  computed: {
    interp() {
      const list = this.chartData && this.chartData.stuList;
      return buildClassMatrixInterpFromStuList(list, this.gradeValue, this.factorMap);
    },
    visibleQuads() {
      return (this.interp && this.interp.quads) ? this.interp.quads.filter((q) => q.visible) : [];
    },
  },
}
</script>

<style lang="less" scoped>
.class-quadrant-interp {
  flex: 1;
  min-width: 0;
  margin: 20px 54px 0;
  box-sizing: border-box;
  /* 外层灰底：对齐校级 .conclusion */
  border: 1px solid transparent;
  border-radius: 10px;
  background: #fafafa;
  padding: 25px;

  /* 配色与校级 matrix_interpretation 对齐 */
  .class-quad-title {
    display: inline-block;
    align-self: flex-start;
    width: auto;
    min-width: 0;
    padding: 0 18px;
    height: 32px;
    background: #01B58C;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 14px;
  }

  .class-quad-card {
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    background: #fff;
    padding: 20px 24px 22px;
  }

  .class-quad-block {
    & + .class-quad-block {
      margin-top: 20px;
      padding-top: 18px;
      border-top: 1px dashed #e5ebe9;
    }

    p {
      margin: 0 0 8px;
      font-size: 15px;
      color: #666;
      line-height: 28px;
    }
  }

  .class-quad-subtitle {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    margin-bottom: 10px;
    padding-left: 10px;
    border-left: 3px solid #01B58C;
    line-height: 1.2;
  }

  .class-quad-overview {
    margin-top: 4px !important;
    margin-bottom: 14px !important;
    padding: 12px 14px;
    background: #f4fbf8;
    border-radius: 8px;
    border: 1px solid #d9efe8;
    font-size: 15px !important;
    line-height: 28px !important;
    color: #555 !important;
  }

  .class-quad-item {
    margin-top: 12px;
    padding: 12px 14px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #efefef;

    & + .class-quad-item {
      margin-top: 12px;
    }

    p {
      margin: 0 0 6px;
      font-size: 15px;
      line-height: 26px;
      color: #666;
    }

    .class-quad-item-head {
      margin-bottom: 8px !important;
      color: #333;
      font-weight: 600;
    }

    .class-quad-label {
      color: #333;
      font-weight: 600;
    }

    .class-quad-advice {
      margin-bottom: 0 !important;
      color: #888;
    }
  }

  .Comment_highlight {
    color: #E96F02;
    font-weight: bold;
  }
}
</style>
